import React, { useState } from "react";
import ModalVideo from "react-modal-video";

const Video = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className="shane_tm_section">
      <div className="shane_tm_business_video" id="home">
        <div className="bg">
          <div
            className="image jarallax"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/video/1.jpg"
              })`,
            }}
          ></div>
        </div>
        {/* End .bg */}

        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpen}
          videoId="DIfxwE3h5Xg"
          onClose={() => setOpen(false)}
        />

        <div className="content">
          <div data-aos="fade-up" data-aos-duration="1200">
            <span className="rounded" onClick={() => setOpen(true)}></span>
          </div>
        </div>
        {/* End .content */}
      </div>
      {/* End .shane_tm_business_video */}
    </div>
  );
};

export default Video;